import React from "react";

import TrialBtnLink from "../../../Menus/MainNavMenu/sharedComponents/TrialBtnLink";
import useShowNavStore from "../../../../sp-state/useShowNavStore";
import useShowPollenNavStore from "../../../../sp-state/useShowPollenNavStore";
import useWindowSize from "../../../../hooks/useWindowSize";

const PollenTrialCta: React.FC = props => {
  const { showNav } = useShowNavStore(state => state);
  const { showPollenNav } = useShowPollenNavStore(state => state);
  const { width: windowWidth } = useWindowSize();

  const withBtnTrial =
    (!showNav && !showPollenNav) ||
    (showPollenNav && windowWidth >= 768 && windowWidth <= 1023);

  return (
    <>
      {withBtnTrial && (
        <TrialBtnLink btnText="Start For Free" btnPath="/sign-up" />
      )}
    </>
  );
};

export default PollenTrialCta;
